import { PreferenceProvider } from '@/context/PreferenceProvider';
import { AppRoutes } from '@/routes';
import { useAuth } from '@/contexts/AuthContext';
import { OktoberLoadingScreen } from '@/components/oktober/OktoberLoadingScreen';
import { Toaster } from '@/components/ui/sonner';
import { useLocation } from 'react-router-dom';
import '@/lib/i18n';

function AppContent() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <OktoberLoadingScreen />;
  }

  return <AppRoutes />;
}

function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login' || location.pathname === '/invitation';

  return (
    <PreferenceProvider singleTheme="light">
      <AppContent />
      <Toaster position={isLoginPage ? 'bottom-right' : 'top-right'} />
    </PreferenceProvider>
  );
}

export default App;
